const KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];
const STORAGE_KEY = 'storefront_attribution';

/**
 * Visitors who arrive without campaign tags from an AI assistant or a social
 * app are still attributed, so the Attribution report shows what ChatGPT,
 * Perplexity, Instagram… bring in.
 */
const REFERRERS = [
  [/(^|\.)(chatgpt\.com|chat\.openai\.com)$/, 'chatgpt.com', 'ai_assistant'],
  [/(^|\.)perplexity\.ai$/, 'perplexity.ai', 'ai_assistant'],
  [/(^|\.)gemini\.google\.com$/, 'gemini.google.com', 'ai_assistant'],
  [/(^|\.)copilot\.microsoft\.com$/, 'copilot.microsoft.com', 'ai_assistant'],
  [/(^|\.)claude\.ai$/, 'claude.ai', 'ai_assistant'],
  [/(^|\.)(meta\.ai|you\.com|phind\.com|chat\.mistral\.ai|grok\.com|deepseek\.com)$/, null, 'ai_assistant'],
  [/(^|\.)(instagram\.com|l\.instagram\.com)$/, 'instagram', 'social'],
  [/(^|\.)(facebook\.com|fb\.com|m\.facebook\.com|lm\.facebook\.com)$/, 'facebook', 'social'],
  [/(^|\.)(tiktok\.com)$/, 'tiktok', 'social'],
  [/(^|\.)(t\.co|x\.com|twitter\.com)$/, 'x', 'social'],
];

export const fromReferrer = (referrer) => {
  try {
    const host = new URL(referrer).hostname.toLowerCase();
    if (host === window.location.hostname) return {};
    const match = REFERRERS.find(([pattern]) => pattern.test(host));
    return match ? { utm_source: match[1] || host, utm_medium: match[2] } : {};
  } catch { return {}; }
};

export const captureAttribution = () => {
  try {
    const query = new URLSearchParams(window.location.search);
    let found = Object.fromEntries(KEYS.map((key) => [key, query.get(key)?.slice(0, 120) || null]).filter(([, value]) => value));
    if (!Object.keys(found).length && !sessionStorage.getItem(STORAGE_KEY)) found = fromReferrer(document.referrer);
    if (Object.keys(found).length) sessionStorage.setItem(STORAGE_KEY, JSON.stringify(found));
    return found;
  } catch { return {}; }
};

export const currentAttribution = () => {
  try {
    const found = captureAttribution();
    if (Object.keys(found).length) return found;
    const stored = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || '{}');
    return Object.fromEntries(KEYS.map((key) => [key, typeof stored[key] === 'string' ? stored[key].slice(0, 120) : null]).filter(([, value]) => value));
  } catch { return {}; }
};
